import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NoteService } from '@app/services/note.service';
import { GlobalUtil } from '@app/modules/common/shared/util/global-util';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { SidebarService } from '@services/sidebar.service';

@Component({
  selector: 'app-note-form',
  templateUrl: './note-form.component.html',
  styleUrls: null,
  providers: [SidebarService]
})
export class NoteFormComponent extends BaseComponent {
  noteFormGroup: FormGroup;
  dataLoaded = false;
  formSubmitted = false;
  globalUtil = GlobalUtil;
  ids = [];

  constructor(
    public activatedRoute: ActivatedRoute,
    public noteService: NoteService,
    public sidebarService: SidebarService,
    public state: State,
    private formBuilder: FormBuilder
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService: sidebarService,
      state: state,
      modelService: noteService
    });

    this.setPageVars({
      sidebar: ''
    });

    this.initialFormGroupSetup();

    const id = this.routeParams['id'];

    if (id === undefined) {
      this.dataLoaded = true;
    } else {
      this.modelService.getOne(id).subscribe((result: any) => {
        console.log(result);
        this.dataLoaded = true;
        this.noteFormGroup.patchValue(result);
      });
    }

  }

  // All the public methods
  get controls(): any {
    return this.noteFormGroup.controls;
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }

  public save(): void {
    const uuid = this.controls.uuid.value;
    this.formSubmitted = true;
    if (uuid) {
      this.noteService.patchById(uuid, this.noteFormGroup.value)
        .subscribe(result => {
          this.SavedMessage(result);
        });
    } else {
      this.noteService.create(this.noteFormGroup.value).subscribe(result => this.SavedMessage(result));
    }

    setTimeout (() => {
      this.formSubmitted = false;
    }, 1000);

  }

  // All the private methods
  private initialFormGroupSetup(): void {
    this.noteFormGroup = this.formBuilder.group({
      uuid: [null],
      user_uuid: [null, [Validators.required]],
      note_category_uuid: [null, [Validators.required]],
      title: [null, [Validators.required, Validators.maxLength(this.globalUtil.Validation.GENERAL_FIELD_MAX_LENGTH)]],
      body: [null],
    });
  }

  private SavedMessage(data: Object) {
    this.state.message({ ['NoteIndexUpdate']: true });
    this.closeSlideout();
  }

}
